import get from 'lodash/get';
import isArray from 'lodash/isArray';
import find from 'lodash/find';
import every from 'lodash/every';

class PriorityWatcher {
  _defaultItem = null;

  _idFieldName = '';

  _resultQueue = null;

  constructor(defaultItem) {
    this._defaultItem = defaultItem;
    this.clear();
  }

  init(array, idFieldName) {
    this._idFieldName = idFieldName;

    if (isArray(array) && array.length) {
      this._resultQueue = array;
    }
  }

  clear() {
    this._resultQueue = null;
    this._idFieldName = '';
  }

  addItem(item, idFieldName) {
    const obj = find(this._resultQueue, (queueItem) => get(queueItem, this._idFieldName, {}) === get(item, idFieldName, {}));

    if (typeof obj !== 'undefined') {
      obj.results = item;
    } else {
      throw new Error('Unknown result');
    }
  }

  getHighPriorityItem() {
    let result = null;

    every(this._resultQueue, (queueItem) => {
      const resultsCount = get(queueItem, 'results.resultsCount');
      if (typeof resultsCount === 'undefined') {
        return false; // Current item is not loaded. We need to stop search.
        // eslint-disable-next-line no-else-return
      } else if (resultsCount > 0) {
        result = queueItem;
        return false; // We have loaded not empty item with maximum priority
      } else {
        return true; // Get next item
      }
    });

    return result;
  }

  getHighPriorityItemResults() {
    return get(this.getHighPriorityItem(), 'results');
  }

  getFirstNotLoaded() {
    const result = find(this._resultQueue, (queueItem) => {
      const resultsCount = get(queueItem, 'results.resultsCount');
      return typeof resultsCount === 'undefined';
    });

    return result || this._defaultItem;
  }

  isAllResultsLoaded() {
    return every(this._resultQueue, (itm) => typeof itm.results !== 'undefined');
  }

  isAllZeroCount() {
    return this.isAllResultsLoaded() && every(this._resultQueue, (itm) => itm.results.resultsCount === 0);
  }
}

export default PriorityWatcher;
